import { render, staticRenderFns } from "./Mini_LangSchoolFeedback.vue?vue&type=template&id=ed107dea&scoped=true&"
import script from "./Mini_LangSchoolFeedback.vue?vue&type=script&lang=js&"
export * from "./Mini_LangSchoolFeedback.vue?vue&type=script&lang=js&"
import style0 from "./Mini_LangSchoolFeedback.vue?vue&type=style&index=0&id=ed107dea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed107dea",
  null
  
)

export default component.exports